import { __t } from '@/lib/helpers'
import Boost from './boost.ts'
import {
  ACCESS_LEVELS,
} from '@/lib/consts.ts'
import { PROMOTION_ROUTE_KEYS } from '@/components/promotion/consts'

export default {
  path: 'promotion',
  name: 'promotion',
  meta: {
    title: __t('routes.promotion.title'),
    hintKey: 'hintFeatureMarketing',
    useSmartlook: true,
  },
  component: () => import('@/views/business/promotion/index.vue'),
  children: [
    {
      path: 'invite',
      name: 'promotion--invite',
      meta: {
        title: __t('routes.promotion.invite.title'),
        subtitle: __t('routes.promotion.invite.subtitle'),
        icon: {
          inactive: 'promotion/invite-inactive.svg',
          active: 'promotion/invite-active.svg',
          color: '#ffce49',
        },
        key: PROMOTION_ROUTE_KEYS.INVITE_CUSTOMERS,
        hintKey: 'hintFeatureAddInviteClients',
        restrictedAccessLevels: [ACCESS_LEVELS.STAFF],
      },
      component: () => import('@/views/business/promotion/invite.vue'),
    },
    {
      path: 'message-clients',
      name: 'message-clients',
      meta: {
        title: __t('routes.promotion.message-your-clients.title'),
        subtitle: __t('routes.promotion.message-your-clients.subtitle'),
        icon: {
          inactive: 'promotion/ic_message.svg',
          active: 'promotion/ic_message_active.svg',
          color: '#84dc6a',
        },
        key: PROMOTION_ROUTE_KEYS.MESSAGE_BLAST,
        hintKey: 'hintFeatureMessageBlasts',
        restrictedAccessLevels: [ACCESS_LEVELS.STAFF, ACCESS_LEVELS.ADVANCED],
        defaultSubroute: {
          name: 'message-clients.dashboard',
        },
      },
      component: () => import('@/views/business/promotion/message-your-clients/index.vue'),
      children: [
        {
          path: ':id/edit',
          name: 'message-clients.edit',
          component: () => import('@/components/promotion/message-your-clients/blast-edit.vue'),
        },
        {
          path: ':id',
          name: 'message-clients.preview',
          component: () => import('@/components/promotion/message-your-clients/blast-preview.vue'),
        },
        {
          path: '',
          name: 'message-clients.dashboard',
          component: () => import('@/components/promotion/message-your-clients/dashboard.vue'),
        },
      ],
    },
    Boost,
    {
      path: 'special-offers',
      name: 'promotion.special-offers',
      meta: {
        title: __t('routes.promotion.special-offers.title'),
        subtitle: __t('routes.promotion.special-offers.subtitle'),
        icon: {
          inactive: 'promotion/promotion-inactive.svg',
          active: 'promotion/promotion-active.svg',
          color: '#ff9300',
        },
        key: PROMOTION_ROUTE_KEYS.SPECIAL_OFFERS,
        hintKey: 'hintsFeaturePromotions',
        restrictedAccessLevels: [ACCESS_LEVELS.STAFF, ACCESS_LEVELS.ADVANCED],
      },
      component: () => import('@/views/business/promotion/special-offers/index.vue'),
      children: [
        {
          path: 'flash-sale',
          name: 'promotion.flash-sale',
          meta: {
            title: __t('routes.promotion.flash-sale.title'),
            subtitle: __t('routes.promotion.flash-sale.subtitle'),
            key: 'flash-sale',
            hintKey: 'hintFeatureFlashSale',
          },
          component: () => import('@/views/business/promotion/special-offers/flash-sale.vue'),
        },
        {
          path: 'happy-hours',
          name: 'promotion.happy-hours',
          meta: {
            title: __t('routes.promotion.happy-hours.title'),
            subtitle: __t('routes.promotion.happy-hours.subtitle'),
            key: 'happy-hours',
            hintKey: 'hintFeatureHappyHours',
          },
          component: () => import('@/views/business/promotion/special-offers/happy-hours/index.vue'),
          children: [
            {
              path: ':dayOfWeek',
              name: 'promotion.happy-hours.day',
              component: () => import('@/views/business/promotion/special-offers/happy-hours/day.vue'),
              meta: {},
            },
          ],
        },
        {
          path: 'peak-hours',
          name: 'promotion.peak-hours',
          meta: {
            title: __t('routes.promotion.premium-hours.title'),
            subtitle: __t('routes.promotion.premium-hours.subtitle'),
            key: 'peak-hours',
          },
          component: () => import('@/views/business/promotion/special-offers/peak-hours/index.vue'),
          children: [
            {
              path: ':dayOfWeek',
              name: 'promotion.peak-hours.day',
              component: () => import('@/views/business/promotion/special-offers/peak-hours/day.vue'),
              meta: {},
            },
          ],
        },
        {
          path: 'last-minute',
          name: 'promotion.last-minute',
          meta: {
            title: __t('routes.promotion.last-minute.title'),
            subtitle: __t('routes.promotion.last-minute.subtitle'),
            key: 'last-minute',
            hintKey: 'hintFeatureLastMinute',
          },
          component: () => import('@/views/business/promotion/special-offers/last-minute.vue'),
        },
      ],
    },
    {
      path: 'social-media',
      name: 'promotion.social-media',
      meta: {
        title: __t('routes.promotion.social-media.title'),
        subtitle: __t('routes.promotion.social-media.subtitle'),
        icon: {
          inactive: 'promotion/ico_share.svg',
          active: 'promotion/ico_share_active.svg',
          color: '#5cb3fa',
        },
        key: PROMOTION_ROUTE_KEYS.SOCIAL_MEDIA,
        hintKey: 'hintFeatureSocialPost',
        restrictedAccessLevels: [ACCESS_LEVELS.STAFF, ACCESS_LEVELS.ADVANCED],
      },
      component: () => import('@/views/business/promotion/social-media.vue'),
    },
    {
      path: 'google-business-profile',
      name: 'promotion.google-business-profile',
      component: () => import('@/views/business/promotion/google-business-profile/index.vue'),
    },
    {
      path: 'visibility-promotion',
      name: 'promotion.visibility-promotion',
      meta: {
        key: PROMOTION_ROUTE_KEYS.VISIBILITY_PROMOTION,
        restrictedAccessLevels: [ACCESS_LEVELS.STAFF, ACCESS_LEVELS.ADVANCED, ACCESS_LEVELS.RECEPTION],
      },
      component: () => import('@/views/business/promotion/visibility-promotion/index.vue'),
    },
  ],
}
